export default __webpack_public_path__ + "static/media/avatar-bts-suga.94d813b7.png";